const foreign_worker_group_query = (groupId) => `query {
  getForeignWorkerGroupByGroupId(group_id:"${groupId}") {
    id,
    ForeignWorkerGroupFormData {
    new_group_fw_group_name,
    new_group_fw_profiles,
    new_group_fw_num_profiles,
    }
    }
    }
    `;

export default foreign_worker_group_query;
